<script>
import round from './CompetitionRound.vue';
import iCompetition from './_competition.js';
import _ from "lodash";

export default {
  name: 'competition',

  mixins: [iCompetition],

  data() {
    return {
      home_url: home_url,
      referrer: referrer,
      competition_id: competition_id,
      competition: {},
      results: null,
      rounds: null,
      points_table: null,
      layout: 'grid',
      isLoading: true,
      hasProgressionComps: false
    }
  },

  components: {
    round,
  },

  template: `
    <div class="dash-public-plugin-container dash-public-plugin-competition" v-bind:class="{'is-loading': isLoading, 'is-scrollable': true}">
        <div class="dash-public-plugin-container-header is-tab">
          <div>
            <div v-if="hasProgressionComps">
              <a class="go-back" :href="home_url + '/competitions/?progression_intake_id=' + competition.intake_id">Back to competitions</a>
            </div>
            <div v-else-if="referrer">
              <button class="go-back" onclick="history.back(-1)">Go back</button>
            </div>
            <div v-else>
              <a class="go-back" :href="home_url + '/competitions'">Go back</a>
            </div>
          </div>
          
          <div class="header-row">
            <div class="header-title">{{ competition.display_name }}</div>
            <div class="header-actions"></div>
          </div>

          <nav class="container-tabs-nav">
            <a aria-pressed="true">Rounds</a>
            <a aria-pressed="false"><span class="show-md">Event</span> Information</a>
            <a v-if="competition.competition_type == 'round robin'" aria-pressed="false"><span class="show-md">Points</span> Table</a>
          </nav>
        </div>

        <div class="dash-public-plugin-container-content is-tab">
          <div class="container-tabs">
            
            <div class="tab is-collapsed" aria-expanded="true">
              <div class="competition-container">
                <div class="competition-layout">
                  <button v-on:click="setCompetitionLayout('grid')" v-bind:class="{ 'is-active': layout === 'grid'}">
                    <i class="fas fa-th-large"></i> Grid View
                  </button>
                  <button v-on:click="setCompetitionLayout('list')" v-bind:class="{ 'is-active': layout === 'list'}">
                    <i class="fas fa-th-list" aria-hidden="true"></i>List View
                  </button>
                </div>
                <div v-if="rounds" id="competition-rounds" class="competition-rounds" v-bind:class="layout">
                  <round
                      v-for="round in rounds"
                      v-bind:key="round.key"
                      v-bind:rounds="rounds"
                      v-bind:round="round"
                      v-bind:competition="competition"
                      v-bind:results="results">
                  </round>
                </div>
              </div>
            </div>

            <div class="tab" aria-expanded="false">
                <div v-if="competition.notes" class="competition-notes" v-html="this.$options.filters.notesFormat(competition.notes)"></div>
                <div v-else>No information found for this event.</div>
            </div>

            <div v-if="competition.competition_type == 'round robin'" class="tab" aria-expanded="false">
                <div class="table-contaner">
                  <table class="competition-points-table">
                    <thead>
                      <tr>
                        <th class="col-number show-md">&nbsp;</th>
                        <th class="col-name">&nbsp;</th>
                        <th class="col-matches-played show-sm" title="Matches Played">MP</th>
                        <th class="col-wins show-sm" title="Wins">W</th>
                        <th class="col-draws show-md" title="Draws">D</th>
                        <th class="col-losses show-md" title="Losses">L</th>
                        <th class="col-losses show-md" title="Forfeits"">F</th>
                        <th class="col-wins show-md" title="Byes"">B</th>
                        <th class="col-points" title="Points"">Pts</th>
                      </tr>
                    </thead>
                    <tbody v-if="points_table && points_table.application_standings">
                      <tr
                      v-for="entity in points_table.application_standings"
                      v-bind:key="entity.helper_application_id"
                      >
                        <td class="col-number show-md"></td>
                        <td class="col-name"><div class="truncate">{{ entity.application_entity.display_name }}</div></td>
                        <td class="col-matches-played show-sm">{{ entity.games_played }}</td>
                        <td class="col-wins show-sm">{{ entity.wins }}</td>
                        <td class="col-draws show-md">{{ entity.draws }}</td>
                        <td class="col-losses show-md">{{ entity.losses }}</td>
                        <td class="col-losses show-md">{{ entity.forfeits }}</td>
                        <td class="col-wins show-md">{{ entity.byes }}</td>
                        <td class="col-points">{{ entity.points }}</th>
                      </tr>
                    </tbody>
                  </table>
                </div>
            </div>
          </div>
        </div>
    </div>
  `,

  mounted() {
    const $this = this;

    this.getData();

    let competitionsContainer = jQuery('.competition-container');

    jQuery(window).on('resize', _.debounce(function() {
      jsPlumb.repaintEverything();
    }, 150));

    competitionsContainer.scroll(_.debounce(function() {
        competitionsContainer.addClass('is-scrolling');
    }, 50, { 'leading': true, 'trailing': false }));

    competitionsContainer.scroll(_.debounce(function() {
      jsPlumb.repaintEverything();
      competitionsContainer.removeClass('is-scrolling');
    }, 50));


    jQuery(".competition-container").on( "scroll", function() {
      $this.setRoundView();
    });
  },

  methods: {
    getData: function () {
      const $this = this;

      $this.getCompetition(competition_id, function (competition, results) {
        $this.competition = competition;
        $this.results = results;
        $this.isLoading = false;

        if(competition && competition.competition_type == 'round robin') {
          $this.layout = 'list';
        }
      })
    },

    setRoundView() {
      const $this = this;
      const competitionRounds = jQuery('.competition-round');

      if($this.layout == 'grid') {
        competitionRounds.each(function( index ) {
          let el = jQuery(this);
          let parentBounding = jQuery('.competition-container')[0].getBoundingClientRect();
          let childBounding = jQuery(this)[0].getBoundingClientRect();
          let relativePosLeft   = childBounding.left - parentBounding.left;

          if(relativePosLeft < -Math.abs((el.width() + 30))) {
            el.addClass('is-out-of-view');
          } else {
            el.removeClass('is-out-of-view');
          }
        });
      } else {
        competitionRounds.removeClass('is-out-of-view');
      }

      setTimeout(() => {
        jsPlumb.repaintEverything();
      }, 50);
    },

    setCompetitionLayout(type) {
      if (type && type !== this.layout) {
        this.layout = type;

        if (this.layout === 'list') {
          jsPlumb.deleteEveryConnection();
          return;
        }

        setTimeout(() => {
          this.setPlumber();
          jsPlumb.repaintEverything();
        }, 200);
      }
    },

    setPlumber() {
      const $this = this;

      if ($this.rounds && $this.rounds.length) {
        $this.rounds.forEach((round) => {
          round.matches.forEach((match) => {
            if (match.entityA && match.entityA.match_progressor_key)
              this.setPlumbNodes(match.entityA.match_progressor_key, match.key);
            if (match.entityB && match.entityB.match_progressor_key)
              this.setPlumbNodes(match.entityB.match_progressor_key, match.key);
            if (match.entityA && match.entityA.pool_progressor_key)
              this.setPlumbNodes(this.getPoolByProgressorKey(match.entityA.pool_progressor_key, competition_id, this.rounds).key, match.key);
            if (match.entityB && match.entityB.pool_progressor_key)
              this.setPlumbNodes(this.getPoolByProgressorKey(match.entityB.pool_progressor_key, competition_id, this.rounds).key, match.key);
          });

          round.pools.forEach((pool) => {
            pool.pool_teams.forEach((team) => {
              if (team.match_progressor_key)
                this.setPlumbNodes(team.match_progressor_key, pool.key);
              if (team.pool_progressor_key)
                this.setPlumbNodes(this.getPoolByProgressorKey(pool.pool_progressor_key, competition_id, this.rounds).key, pool.key);

            });
          });
        });
      }
    },

    setPlumbNodes(e0, e1) {
      jsPlumb.connect({
        connector: ["Flowchart"],
        source: e0,
        target: e1,
        anchor: ["Left", "Right"],
        detachable: false,
        endpoint: ["Rectangle", {
          width: 5,
          height: 5,
          cssClass: "",
        }],
        paintStyle: {
          stroke:"#dddddd",
          strokeWidth:1
        },
        endpointStyle:{ fill:"#dddddd", outlineStroke:"#dddddd", outlineWidth:1 },
      });
    }
  },

  watch: {
    competition: function (value) {
      const $this = this;

      if (value && 'latest_version' in value) {
        let comp_version = JSON.parse(value.latest_version.competition_serialised);

        if (comp_version) {
          if ('rounds' in comp_version) {
            this.rounds = comp_version.rounds;
          }
          if ('points_table' in comp_version) {
            this.points_table = comp_version.points_table;
          }
        }
      }

      if (value.intake_type_id === 'progression' && value.intake_id) {
        this.callApi('GET', '/competitions/my', { progression_intake_id: value.intake_id }, function (result) {
          $this.hasProgressionComps = result && result.length;
        });
      }
    },

    isLoading: function (value) {
      if (!value && this.rounds && this.rounds.length > 0 && this.layout === 'grid') {
        setTimeout(() => {
          this.setPlumber();
        }, 200);
      }
    }
  }
}
</script>